import { createUseStyles } from 'react-jss';

const useStyle = createUseStyles((theme) => ({
  skeleton: (props) => ({
    width: props.width,
    height: props.height,
    overflow: 'hidden',
    position: 'relative',
    backgroundColor: '#f2f2f2',
    background: '-webkit-gradient(linear,left top,right top,color-stop(25%,#f2f2f2),color-stop(40%,#e6e6e6),color-stop(63%,#f2f2f2))',
    background: 'linear-gradient(90deg,#f2f2f2 25%,#e6e6e6 40%,#f2f2f2 63%)',
    backgroundSize: '500% 100%',
    '-webkit-animation': '$skeleton-loading 1.5s ease infinite',
    animation: '$skeleton-loading 1.5s ease infinite',
    animationDirection: theme.direction.value === 'rtl' ? 'reverse' : 'unset',
  }),
  '@keyframes skeleton-loading': {
    '0%': {
      backgroundPosition: '100% 50%',
    },
    '100%': {
      backgroundPosition: '0 50%',
    },
  },
}));

export default useStyle;
